import axios from 'axios';

/**
 * This class returns prepared axios calls that already contain the proper headers and url for each API call in this app.
 * There probably is a better way to do this, but for now this works.
 */
class Fetcher {
  /**
   * Create new instance of Fetcher
   * @param {String} jwtToken Firebase auth token
   */
  constructor(jwtToken) {
    this.axios = axios.create({
      baseURL: `${process.env.REACT_APP_API_SERVER}`,
      withCredentials: true,
      headers: { 'X-Firebase-Authorization': jwtToken },
      // headers: { 'Authorization': `Bearer ${jwtToken}` },
    });
  }

  /**
   * Helper to initialize the Fetcher class
   * @param {String} jwtToken 
   */
  static init(jwtToken) {
    return new Fetcher(jwtToken);
  }

  /**
   * Return axios instance for upload action.
   * @param {String} uploadAction Upload action to perform (form, url or file)
   * @param {FormData} data
   * @param {String} dataset the dataset that should be used for this action
   */

  poiSelect(data, dataset) {
    return this.axios.post(`/poi/select?dataset=${dataset}`, data);
  }

  poiUpload(uploadAction, data, dataset) {
    return this.axios.post(`/poi/upload/${uploadAction}?dataset=${dataset}`, data);
  }
  
  poiProcess(hash, data, dataset) {
    return this.axios.post(`/poi/process/${encodeURIComponent(hash)}?dataset=${dataset}`, data);
  }

  poiProcessStatus(hash, dataset) {
    return this.axios.get(`/poi/process/status/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  poiSave(hash, dataset) {
    return this.axios.post(`/poi/results/save/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  poiSaveStatus(hash, dataset) {
    return this.axios.get(`/poi/results/status/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  poiFetchStats(hash, dataset) {
    return this.axios.get(`/poi/results/stats/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  poiFetchDownloadLink(hash, dataset) {
    return this.axios.get(`/poi/results/url/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }
  /**
   * Return axios instance for upload action.
   * @param {String} uploadAction Upload action to perform (form, url or file)
   * @param {FormData} data
   * @param {String} dataset the dataset that should be used for this action
   */
  ampUpload(uploadAction, data, dataset) {
    return this.axios.post(`/amp/upload/${uploadAction}?dataset=${dataset}`, data);
  }

  ampProcess(hash, data, dataset) {
    return this.axios.post(`/amp/process/${encodeURIComponent(hash)}?dataset=${dataset}`, data);
  }

  ampProcessStatus(hash, dataset) {
    return this.axios.get(`/amp/process/status/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  ampNotify(hash, dataset) {
    return this.axios.get(`/amp/process/notify/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  ampSave(hash, dataset) {
    return this.axios.post(`/amp/results/save/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  ampSaveStatus(hash, dataset) {
    return this.axios.get(`/amp/results/status/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  ampFetchStats(hash, dataset) {
    return this.axios.get(`/amp/results/stats/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  ampFetchDownloadLink(hash, dataset) {
    return this.axios.get(`/amp/results/url/${encodeURIComponent(hash)}?dataset=${dataset}`);
  }

  adminFetchUserList() {
    return this.axios.get(`/admin/users`);
  }

  adminUserUpdate(user, shouldMail) {
    let data = {
      email: user.email,
      displayName: user.displayName,
      client: user.client,
      sendConfirmation: shouldMail,
    }
    return this.axios.post(`/admin/user/${user.uid}/update`, data);
  }
  adminUserCreate(user, shouldMail) {
    let data = {
      email: user.email,
      displayName: user.displayName,
      client: user.client,
      sendWelcome: shouldMail,
    }
    return this.axios.post(`/admin/user/create`, data);
  }
  adminUserDisable(uid) {
    return this.axios.post(`/admin/user/${uid}/disable`);
  }
  adminUserEnable(uid) {
    return this.axios.post(`/admin/user/${uid}/enable`);
  }
  adminUserDelete(uid) {
    return this.axios.post(`/admin/user/${uid}/delete`);
  }

  periscopeGetLink(dataset) {
    return this.axios.get(`/periscope/?dataset=${dataset}`);
  }
}

export default Fetcher;



// WEBPACK FOOTER //
// ./src/util/fetcher.js